<app-landing-pages [dataId]="pageId"></app-landing-pages>